//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "Naranjo",
  data() {
    return {
      form: {
        value1: "0",
        value2: "0",
        value3: "",
        value4: "",
        value5: "0",
        value6: "",
        value7: "0",
        value8: "0",
        value9: "",
        value10: "0",
      },
      hasScore: false,
      disabled: false,
      dataList: [
        { value: "1", name: "是" },
        { value: "0", name: "否" },
        { value: "0", name: "不清楚" },
      ],
      dataList1: [
        { value: "1", name: "是" },
        { value: "0", name: "否" },
        { value: "0", name: "不清楚" },
      ],
      dataList2: [
        { value: "-1", name: "是" },
        { value: "2", name: "否" },
        { value: "0", name: "不清楚" },
      ],
      dataList3: [
        { value: "2", name: "是" },
        { value: "-1", name: "否" },
        { value: "0", name: "不清楚" },
      ],
      dataList4: [
        { value: "1", name: "是" },
        { value: "0", name: "否" },
        { value: "0", name: "不清楚" },
      ],
      dataList5: [
        { value: "2", name: "是" },
        { value: "-1", name: "否" },
        { value: "0", name: "不清楚" },
      ],
      dataList6: [
        { value: "1", name: "是" },
        { value: "0", name: "否" },
        { value: "0", name: "不清楚" },
      ],
      dataList7: [
        { value: "1", name: "是" },
        { value: "0", name: "否" },
        { value: "0", name: "不清楚" },
      ],
      dataList8: [
        { value: "-1", name: "是" },
        { value: "1", name: "否" },
        { value: "0", name: "不清楚" },
      ],
      dataList9: [
        { value: "1", name: "是" },
        { value: "0", name: "否" },
        { value: "0", name: "不清楚" },
      ],
      dataList10: [
        { value: "-1", name: "是" },
        { value: "1", name: "否" },
        { value: "0", name: "不清楚" },
      ],
      
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        let result = (form.value1?1:0)+(form.value2 ? 1 :0) + form.value3
        + form.value4 +
        (form.value5 ? 1:0) +
        form.value6 + 
        (form.value7 ? 1:0) +
        (form.value8 ? 1 : 0) + 
        form.value9 + 
        (form.value10 ? 1 : 0)
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Naranjo.vue